    
function initMapImplantations(){
    var mapWrapper = document.getElementById( 'wikane-map-implantations' );
   
    if ( mapWrapper !== null ) {
       
        // Map style
        var mapStyle = [
          {
            "stylers": [
              { "hue": "#ff0000" },
              { "saturation": -100 }
            ]
          }
        ];
        
        // Map center
        var latlng = new google.maps.LatLng(45.761333,6.319875);
        
        // Maps options
        var myOptions = {
            zoom: 11,
            center: latlng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: mapStyle,
            zoomControlOptions: {style: 'SMALL'},
            scrollwheel: false,
            panControl: false,
            streetViewControl: false
        };
        
        // Map init
        var map = new google.maps.Map(mapWrapper, myOptions);
        
        // Map icons
        var icon = {
            anchor: new google.maps.Point(12,40),
            url: WP_THEME_IMAGES_URL + 'marker.png'
        };
        var iconActive = {
            anchor: new google.maps.Point(12,40),
            url: WP_THEME_IMAGES_URL + 'marker-active.png'
        };
        
        // Map markers variables
        var markerActive = null;
        
        var resetMarkerActive = function(){
            if ( markerActive !== null ) {
                markerActive.setIcon( icon );
            }
        };
        
        // Map infoWindow
        var infoWindow = new google.maps.InfoWindow({
            maxWidth: 200
        });
        
        google.maps.event.addListener(infoWindow, 'closeclick', function() {
            resetMarkerActive();
        });
        
        
        // Map markers
        
        var bounds = new google.maps.LatLngBounds();

        function addPoints(data){
            var myLatlng, marker;
            var markers = new Array();
            
            for (var i = 0, len = data.length; i < len; i++) {
                myLatlng = new google.maps.LatLng(data[i].lat, data[i].lng);
                
                marker = new google.maps.Marker({
                    map: map, 
                    position: myLatlng,
                    title: data[i].title,
                    icon: icon
                });
                
                marker.html = "<div class=\"info-window\"><h3>"+ data[i].title +"</h3><div class=\"content\">"+ data[i].content +"</div></div>";

                markers.push(marker);

                bounds.extend(myLatlng);
                
                google.maps.event.addListener(marker, 'click', function() {
                    resetMarkerActive();
                    
                    markerActive = this;
                    
                    this.setIcon( iconActive );
                    
                    infoWindow.setContent(this.html);
                    infoWindow.open(map,this);
                });
            }
            
            map.fitBounds(bounds);

            var options = {
                maxZoom: 10,
                gridSize: 10,
                styles:
                [{
                    url: WP_THEME_IMAGES_URL + 'marker-cluster.png',
                    height: 44,
                    width: 24,
                    anchor: [4, 0],
                    textColor: '#000000',
                    textSize: 12
                },
                {
                    url: WP_THEME_IMAGES_URL + 'marker-cluster.png',
                    height: 44,
                    width: 24,
                    anchor: [4, 0],
                    textColor: '#000000',
                    textSize: 12
                },
                {
                    url: WP_THEME_IMAGES_URL + 'marker-cluster.png',
                    height: 44,
                    width: 24,
                    anchor: [4, 0],
                    textColor: '#000000',
                    textSize: 12
                }, {
                    url: WP_THEME_IMAGES_URL + 'marker-cluster.png',
                    height: 44,
                    width: 24,
                    anchor: [4, 0],
                    textColor: '#000000',
                    textSize: 12
                }, {
                    url: WP_THEME_IMAGES_URL + 'marker-cluster.png',
                    height: 44,
                    width: 24,
                    anchor: [4, 0],
                    textColor: '#000000',
                    textSize: 12
                }]
            };

            var markerCluster = new MarkerClusterer(map, markers, options);
        }
        
        if ( implantationsArray !== undefined && implantationsArray.length ) {
            addPoints(implantationsArray);
        }
   }
}
//initMapImplantations();